import RequestApi from "../../utils/request";

export default {
	//测试
	TestData:(Data) => {
		// console.log(Data);
		///CMSAccount/Login
		var Url = '/api/Demo/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取验证码
	SendCode:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/SendCode/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//登录登录
	CheckIn:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/CheckIn/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//退出系统
	CheckOut:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/CheckOut/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	
}